import { Block } from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import { BLOCK_IF, type BlockIfData } from '../types';

export function createIfBlock(expression = '', nodes?: Block[]): Block {
    return Block.create({
        type: BLOCK_IF,
        data: { expression } as BlockIfData,
        nodes: nodes && nodes.length > 0 ? nodes : [createParagraph()],
    });
}
